import Model from 'core/model/Model';

class RbacRoleModel extends Model {
  get urlRoot() {
    return '/api/ui/rbac/roles';
  }
}

export default RbacRoleModel;
